<template>
  <div>
    <h1>Benvenuto!</h1>
    <div v-if="!this.$route.query.queryURL" class="text-justify col-8 mx-auto">
      <br />Ti abbiamo inviato una email per verificare che il tuo indirizzo
      email sia corretto. <br />Per favore controlla la tua casella di posta.
      <div v-if="!alreadyVerified">
        <br />Non hai ricevuto la mail? Clicca su "reinvia" per inviarla
        nuovamente.
        <br />
        <div v-if="!hasResend" class="text-center mx-auto my-3">
          <b-button variant="primary" @click="resend">Reinvia</b-button>
        </div>
        <p v-else>Mail inviata con successo!</p>
      </div>
      <p v-else class="text-danger">
        Il tuo indirizzo mail risulta già verificato
        <br />
        <b-button variant="primary" @click="goTo">Ok</b-button>
      </p>
    </div>
    <div v-if="hasVerified" class="my-3 py-3 text-justify col-6 mx-auto">
      Il tuo indirizzo di posta elettronica è stato confermato.
      <br />Ora puoi completare la tua registrazione
      <br />
      <b-button
        block
        variant="primary"
        @click="goTo"
        class="font-weight-bold mt-4"
        >Completa la tua registrazione</b-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "VerifyEmail",
  data() {
    return {
      queryURL: this.$route.query.queryURL,
      hasVerified: false,
      alreadyVerified: false,
      hasResend: false,
    };
  },
  methods: {
    verifyEmail() {
      this.$axios
        .get(this.queryURL)
        .then((res) => {
          // console.log("res verify", res);
          this.hasVerified = true;
          this.$emit("has-verified");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goTo() {
      this.$router.push({ name: "RegisterAnagrafica" });
    },
    resend() {
      this.$axios
        .get("/email/resend")
        .then(() => {
          this.hasResend = true;
        })
        .catch((err) => {
          if (err.response.data.data.verificata) {
            this.alreadyVerified = true;
          }
        });
    },
  },
  created() {
    this.$route.query.queryURL && this.verifyEmail();
  },
};
</script>
